<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="">
        <!-- Valuta -->
        <div class="row">
            <div class="col-lg-6 col-12">
                <div class="form-group row">
                        <div class="col-lg-10 col-md-9 col-9">
                            <yt-dropdown-picklist 
                                #autofocus 
                                [ModelName]="'valuta'" 
                                [GetName]="'get'" 
                                [ModelProperty]="'Sifra,Naziv'"
                                [OrderBy]="'Naziv'" 
                                [AllowAddNew]="false" 
                                formControlName="ValutaID" 
                                [Label]="'KURSDOKUMENTSTAVKA.VALUTA.SINGULAR'"
                                (OnItemSelected)="onValutaSelect($event)">
                            </yt-dropdown-picklist>
                         <div class="form-error" *ngIf="submitted && fc.ValutaID.invalid">
                            <span *ngFor="let validation of errorMessages.ValutaID">
                              <span class="error-message" *ngIf="fc.ValutaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                            </span>
                         </div>
                        </div>
                        <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end">
                            <span class="input-group-append">
                                <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.KURSVALUTA.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetExchangeRateDataByDate()" >
                                    <span class="fa fa-fw fa-download"></span>
                                </button><!--[disabled]="loadingCompanyData"-->
                            </span>
                        </div>
                </div>
            </div>
            <!--Vrednost kupovni-->
            <div class="col-lg-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 
                            name="txtKupovni" 
                            [Label]="'KURSDOKUMENTSTAVKA.KUPOVNI.SINGULAR'"
                            formControlName="VredDinK">
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>
            <!-- Vrednost srednji -->
            <div class="col-lg-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 
                            name="txtSrednji" 
                            [Label]="'KURSDOKUMENTSTAVKA.SREDNJI.SINGULAR'"
                            formControlName="VredDinS">
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>

            <!-- Vrednost prodajni -->
            <div class="col-lg-2 col-12">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3 
                            name="txtProdajni" 
                            [Label]="'KURSDOKUMENTSTAVKA.PRODAJNI.SINGULAR'"
                            formControlName="VredDinP">
                        </yt-number-input-v3>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>